import * as React from "react";
const SvgNephrology = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 44"
    {...props}
  >
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#nephrology_svg__a)"
    >
      <path
        stroke={props.invert ? '#FFFFFF' : '#061C57'}
        d="M18.386 9.457c.046-.374.544-4.911-2.528-7.294-2.97-2.29-7.196-.976-9.345.33C.083 6.39-.646 18.02 3.543 23.606c1.817 2.419 4.621 3.916 4.621 3.916 1.698.904 3.423 1.826 5.49 1.415 2.287-.457 4.123-2.365 4.852-4.355 1.512-4.117-1.846-8.288-.988-8.818.582-.356 2.611 1.242 3.958 3.487 1.91 3.186 1.605 6.336 1.43 10.124a148.2 148.2 0 0 0 0 13.711M31.614 9.457c-.046-.374-.544-4.911 2.528-7.294 2.97-2.29 7.196-.976 9.345.33 6.43 3.906 7.159 15.527 2.97 21.114-1.817 2.419-4.621 3.916-4.621 3.916-1.698.904-3.423 1.826-5.49 1.415-2.287-.457-4.123-2.365-4.852-4.355-1.512-4.117 1.846-8.288.987-8.818-.58-.356-2.61 1.242-3.957 3.487-1.91 3.186-1.605 6.336-1.43 10.124a148.2 148.2 0 0 1 0 13.711"
      />
      <path
        stroke={props.color}
        d="M12.27 9.786c0 .447.073 1.324.627 2.209.977 1.598 2.684 1.972 3.007 2.036M13.7 14.03a6.753 6.753 0 0 0-2.27 1.89 6.587 6.587 0 0 0-1.098 2.11M8.524 12.835c.018.329.092.885.406 1.488a3.574 3.574 0 0 0 1.393 1.451M5.415 13.556a2.668 2.668 0 0 0 3.118.74M37.97 9.914c0 .447-.073 1.323-.627 2.209-.978 1.597-2.684 1.972-3.007 2.036M36.54 14.158a6.756 6.756 0 0 1 2.27 1.89c.618.794.932 1.57 1.098 2.109M41.707 12.954a3.669 3.669 0 0 1-.406 1.487 3.573 3.573 0 0 1-1.393 1.452M44.825 13.684a2.668 2.668 0 0 1-3.118.74M7.721 22c.987.392 2.353.822 4.032 1.022 1.67.201 3.09.11 4.142-.036M11.827 23.506c.055.32.11.886-.074 1.552-.13.447-.323.785-.48 1.013M42.057 22c-.987.392-2.352.822-4.031 1.022-1.67.201-3.09.11-4.142-.036M37.952 23.506c-.055.32-.11.886.074 1.552.129.447.323.785.48 1.013"
      />
    </g>
    <defs>
      <clipPath id="nephrology_svg__a">
        <path fill="#fff" d="M0 0h50v44H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNephrology;
